var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 12C0.666748 5.37258 6.03933 0 12.6667 0C19.2942 0 24.6667 5.37258 24.6667 12C24.6667 18.6274 19.2942 24 12.6667 24C6.03933 24 0.666748 18.6274 0.666748 12Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6629 13.3475C11.9549 13.6395 12.3228 13.7767 12.7666 13.7592C13.2105 13.7417 13.5317 13.5811 13.7303 13.2774L16.6912 8.84473C16.7963 8.6812 16.7817 8.53228 16.6474 8.39795C16.5131 8.26363 16.3642 8.24903 16.2006 8.35415L11.768 11.3151C11.4643 11.5253 11.2979 11.8436 11.2686 12.27C11.2394 12.6963 11.3709 13.0555 11.6629 13.3475ZM7.9135 16.5011C7.65653 16.5011 7.42 16.4457 7.20392 16.3347C6.98783 16.2237 6.81555 16.0573 6.68707 15.8354C6.38338 15.2864 6.14978 14.717 5.98625 14.1271C5.82273 13.5373 5.74097 12.927 5.74097 12.2962C5.74097 11.3268 5.92493 10.4157 6.29286 9.56306C6.66079 8.7104 7.16012 7.96871 7.79085 7.33797C8.42159 6.70724 9.16328 6.20791 10.0159 5.83998C10.8686 5.47205 11.7797 5.28809 12.7491 5.28809C13.7069 5.28809 14.6063 5.46913 15.4473 5.83122C16.2882 6.19331 17.0241 6.6868 17.6548 7.31169C18.2856 7.93658 18.7878 8.6666 19.1616 9.50174C19.5354 10.3369 19.7281 11.2333 19.7398 12.1911C19.7514 12.8335 19.6784 13.4613 19.5208 14.0746C19.3631 14.6878 19.1207 15.2747 18.7937 15.8354C18.6652 16.0573 18.4929 16.2237 18.2768 16.3347C18.0607 16.4457 17.8242 16.5011 17.5672 16.5011H7.9135Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiles);
export default __webpack_public_path__ + "static/media/miles.9dc84f6fb212c8fff60fc6f4c2843bfc.svg";
export { ForwardRef as ReactComponent };